import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ColumnTypeEnum } from '@y42/json-schema';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DatasourceColumnBackendModel, DatasourceColumnUIModel } from '../models';
import { TableColumnsState, TableColumnsStore } from './table-columns.store';

@Injectable({ providedIn: 'root' })
export class TableColumnsQuery extends QueryEntity<TableColumnsState> {
  constructor(protected store: TableColumnsStore) {
    super(store);
  }

  readonly selectEnhancedUiColumns$: Observable<DatasourceColumnUIModel[]> = this.selectAll().pipe(
    map((columns) => columns.map(this.enhanceModel)),
  );

  readonly selectAllWithCalculatedField$: Observable<DatasourceColumnUIModel[]> = this.selectEnhancedUiColumns$.pipe(
    map((res) =>
      res.concat([
        {
          field_name: 'calculated_field',
          data_type: ColumnTypeEnum.Numeric,
          description: '',
          isDeleted: false,
          hasDiffType: false,
          isCalculatedField: true,
          headerClass: [],
        } as DatasourceColumnUIModel,
      ]),
    ),
  );

  getAllEnhancedUiColumns(): DatasourceColumnUIModel[] {
    return this.getAll().map(this.enhanceModel);
  }

  private enhanceModel(column: DatasourceColumnBackendModel): DatasourceColumnUIModel {
    return {
      ...column,
      isDeleted: false,
      hasDiffType: false,
      description: '',
      isCalculatedField: false,
    };
  }
}
